const basePageTitle = 'LMS';
const pageTitleTemplate = `${basePageTitle} > {title}`;

export { pageTitleTemplate, basePageTitle };
